import script from "./CalendarEventsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalendarEventsView.vue?vue&type=script&setup=true&lang=ts"

import "./CalendarEventsView.vue?vue&type=style&index=0&id=2105d81a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2105d81a"]])

export default __exports__